<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="warehouse"
            :name="$t('fields.warehouses').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-select
            :items="warehouses"
            v-model="form.warehouse_to"
            item-text="name"
            item-value="id"
            :label="$t('fields.warehouses')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { warehousesService } from '../../../utils/services/warehouses.service';

  export default {
    name: 'WarehouseTransferModal',
    components: { },
    data() {
      return {
        stored: null,
        currentWarehouse: 0,
        warehouses: [],
        enableResearchInBook: true,
        form: {
          warehouse_to: null,
        },

        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      async fetchWarehouses() {
        return warehousesService.index({
          notIn: this.currentWarehouse,
        })
        .then(response => {
            this.warehouses = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },


      cancel() {
        this.hideModal({});
      },
    },
    async created() {
      this.loadingModal(true);
      this.currentWarehouse = this.data.stored.warehouse_id;
      await this.fetchWarehouses();
      this.loadingModal(false);
    },
  };
</script>
